<template>
    <div>
        <static-loading-indicator-icon></static-loading-indicator-icon>

        <div v-if="post !== null">
            <div class="card shadow-sm">
                <!-- Placeholder if Kiss Video not available -->
                <img class="card-img-top rounded" :src="post.thumbnail_url" @load="imageLoaded = true"/>

                <!-- Loading indicator if image is not loaded -->
                <div class="text-center bg-light" v-if="!imageLoaded" style="padding-top: 80px; padding-bottom: 80px;">
                    <i class="mdi mdi-spin mdi-autorenew mdi-36px text-primary"></i>
                </div>

                <div class="card-body">
                    <h3 class="oswald">
                        {{ post.title }}
                    </h3>
                    <div>
                    <span class="text-muted font-weight-bolder mt-2 text-small">
                        {{ $date(post.creted_at).format('DD.MM.YYYY') }}
                    </span>
                    </div>

                    <p class="mt-4" v-html="post.contents"></p>


                    <div class="mt-5" v-if="post.files.length">
                        <hr>
                        <page-header :title="$t('pages.locker.my_blog.downloads')"></page-header>

                        <div class="row">
                            <div class="col-md-4 col-12 mb-4" v-for="file in post.files">
                                <div class="card bg-light">
                                    <div class="card-body">
                                        <i class="mdi mdi-file-document-box-outline"></i>
                                        <span class="text-primary font-weight-bold oswald">
                                            {{ file.name }}
                                        </span>
                                        ({{ convertBytesToHumanReadable(file.size)}})
                                        <div class="mt-3">
                                            <a :href="file.url" class="btn btn-outline-dark btn-sm" target="_blank">
                                                {{ $t('pages.subscription.invoices.download') }}
                                            </a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StaticLoadingIndicatorIcon from "../Includes/StaticLoadingIndicatorIcon";
import BlogRepository from "../../repositories/Blog/BlogRepository";
import PageHeader from "../Includes/PageHeader";

export default {
    name: "BlogPost",
    components: {PageHeader, StaticLoadingIndicatorIcon},
    data: () => ({
        imageLoaded: false,
        post: null,
    }),
    mounted() {
        this.getPost();
    },
    methods: {
        getPost() {
            BlogRepository.getPostBySlug(this.slug).then(res => {
                this.post = res.data;
            });
        }
    },
    computed: {
        slug() {
            return this.$route.params.slug;
        }
    }
}
</script>

<style scoped>

</style>
